// extracted by mini-css-extract-plugin
export default {"subsectionTitleLabel":"HypertensionBasicCareComponent_subsectionTitleLabel__7TXa2","dataBlockWrapper":"HypertensionBasicCareComponent_dataBlockWrapper__XYgKL"};